import { getMilestoneAnchor } from '../../../utils/milestoneUtils';
import { MemoizedMilestoneNode } from '../MemoizedNodes';

export default function MilestoneNodeItem({
  task,
  commonProps,
  handlers,
  cardDisplaySettings,
  allTasks,
  nestedSprints,
  allSprints,
  statuses,
  onMilestoneAnchorChange,
  positionsToUse = {},
}) {
  const hostId = getMilestoneAnchor(task)?.hostTaskId;
  const hostPosition = hostId ? positionsToUse[hostId] : null;

  return (
    <MemoizedMilestoneNode
      {...commonProps}
      hostPosition={hostPosition}
      cardDisplaySettings={cardDisplaySettings}
      allTasks={allTasks}
      nestedSprints={nestedSprints}
      allSprints={allSprints}
      statuses={statuses}
      onAnchorChange={onMilestoneAnchorChange}
      onDelete={handlers.onDelete}
      onCopy={handlers.onCopy}
      onDuplicate={handlers.onDuplicate}
    />
  );
}
